'use client';

import { useEffect, useLayoutEffect, useState } from 'react';

import { UiModPortalBase } from '@/fo/ui/mod/portal/base';
import { utilDecodeHtmlEntities } from '@/fo/util/decode-html-entities';

import { styles } from './UiModFootnoteBase.styles';

export interface UiModFootnoteBaseProps {
  id: string;
  text: string;
}

const SUP_KEY = '{sup}';

const CONTAINER_ID = 'banner-footnote';

/** Глобальная мутирующая переменная для хранения ID сносок */
let IDS: string[] = [];

const getPortalContainer = () => document.getElementById(CONTAINER_ID);

/**
 * Компонент для отображения сносок
 * Использует UiModPortalBase для отображения сносок в конце страницы
 */
export function UiModFootnoteBase({ id, text }: UiModFootnoteBaseProps) {
  const slots = styles();
  const [index, setIndex] = useState(0);

  useLayoutEffect(() => {
    if (IDS.includes(id)) {
      setIndex(-1);
    } else {
      IDS.push(id);
      setIndex(IDS.indexOf(id));
    }

    return () => {
      IDS = IDS.filter((note) => note !== id);
    };
  }, [id]);

  return (
    <UiModPortalBase getContainer={getPortalContainer}>
      <p className={slots.base({ hidden: index < 0 || !text })}>
        {`${index + 1} - `}
        {text}
      </p>
    </UiModPortalBase>
  );
}

export const FootnoteContainer = () => {
  const slots = styles();
  return (
    <div
      id={CONTAINER_ID}
      className={slots.container()}
    />
  );
};

interface ContentWithFootnoteSupProps {
  id: string;
  content?: string;
  as?: 'span' | 'div';
}

export const ContentWithFootnoteSup = ({
  id,
  content,
  as: Tag = 'span'
}: ContentWithFootnoteSupProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(IDS.indexOf(id));
  }, [id]);

  if (content) {
    const html = utilDecodeHtmlEntities(content).replace(
      SUP_KEY,
      index < 0 ? '' : `<sup>${index + 1}</sup>`
    );

    return (
      <Tag
        dangerouslySetInnerHTML={{ __html: html }}
        suppressHydrationWarning
      />
    );
  }

  return index < 0 ? null : (
    <sup className={!content || index < 0 ? 'hidden' : ''}> {index + 1}</sup>
  );
};
